import moment from 'moment-timezone';

const getAllowedMonthsNav = ({
	locale,
	timezone
}: {
	locale: string;
	timezone: string;
}): { minDateNav: string; maxDateNav: string } => {
	const now = moment().locale(locale).tz(timezone).startOf('month');
	const nextMonth = moment(now).startOf('month').add(5, 'month');
	return { minDateNav: now.toISOString(), maxDateNav: nextMonth.toISOString() };
};

export default getAllowedMonthsNav;
